import { SelectionModel } from '@angular/cdk/collections';
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subject, of } from 'rxjs';
import { takeUntil, catchError } from 'rxjs/operators';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';

import { HeaderComponent } from '../../../shared/components/header/header.component';
import { UiTagComponent } from '../../../shared/components/ui-tag/ui-tag.component';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { LoadingBoxDefaultListComponent } from '../../../shared/components/loading-box-default-list/loading-box-default-list.component';
import { SelectPesquisavelComponent } from '../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import { ConfiguracaoColunasModalComponent, ColunaConfiguracao } from '../../../shared/components/configuracao-colunas-modal/configuracao-colunas-modal.component';

import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { ContasReceberRefinamentoEnum } from '../../../shared/enums/financas/contas-receber-refinamento.enum';
import { PeriodoContasReceberEnum } from '../../../shared/enums/financas/periodo-contas-receber.enum';

import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { MaskService } from '../../../shared/services/mask.service';
import { ContasReceberService } from '../../../shared/services/apis/financas/contas-receber.service';
import { PessoaLookupService } from '../../../shared/services/apis/pessoa/pessoa-lookup.service';

import { ContasReceberGetAllRequest } from '../../../shared/services/requests/financas/contas-receber-get-all.request';
import { ListPessoaIdsRequest } from '../../../shared/services/requests/pessoa/list-pessoa-ids-request';
import { ContasReceberGetAllResponse } from '../../../shared/services/responses/financas/contas-receber-get-all.response';
import { ContasReceberGridItemStruct } from '../../../shared/services/structs/financas/contas-receber-grid-item.struct';
import { StatusContasReceberEnum } from '../../../shared/enums/financas/status-contas-receber.enum';
import { StatusIntegracaoBoletoEnum } from '../../../shared/enums/integracao-financas-banco/status-integracao-boleto.enum';
import { AbntPipe } from '../../../shared/pipes/abnt.pipe';
import { CustomDateAdapter } from '../../../shared/services/custom-date-adapter';
import { LimitDateValidator } from '../../../shared/validators/limit-date.validator';
import { GerarCobrancaDialogComponent } from './dialogs/gerar-cobranca-dialog/gerar-cobranca-dialog.component';
import { ImpressaoContasReceberDialogComponent, ImpressaoContasReceberDialogData } from './dialogs/impressao-contas-receber-dialog/impressao-contas-receber-dialog.component';
import { ImportarContasReceberDialogComponent } from './dialogs/importar-contas-receber-dialog/importar-contas-receber-dialog.component';
import { EditarContasMassaDialogComponent, EditarContasMassaDialogData } from './dialogs/editar-contas-massa-dialog/editar-contas-massa-dialog.component';
import { AlterarCategoriaDialogComponent, AlterarCategoriaDialogData } from './dialogs/alterar-categoria-dialog/alterar-categoria-dialog.component';
import { AlterarTagsDialogComponent, AlterarTagsDialogData } from './dialogs/alterar-tags-dialog/alterar-tags-dialog.component';
import { ReceberContasDialogComponent, ReceberContasDialogData } from './dialogs/receber-contas-dialog/receber-contas-dialog.component';
import { ExtracaoDadosData, ExtracaoDadosModalComponent, FiltroExtracao } from '../../../shared/components/extracao-dados-modal/extracao-dados-modal.component';
import { OrigemPedidoExportacaoEnum } from '../../../shared/enums/batch-extracao-dados/origem-pedido-exportacao.enum';
import { TipoExtracaoEnum } from '../../../shared/enums/batch-extracao-dados/tipo-extracao.enum';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { ConfirmAcaoRecorrenteDialogComponent } from './dialogs/confirm-acao-recorrente-dialog/confirm-acao-recorrente-dialog.component';
import { AlterarFormaRecebimentoDialogComponent, AlterarFormaRecebimentoDialogResult } from './dialogs/alterar-forma-recebimento-dialog/alterar-forma-recebimento-dialog.component';
import { ContasReceberBulkRequest } from '../../../shared/services/requests/financas/contas-receber-bulk.request';
import { ContasReceberBulkAlterarFormaRecebimentoRequest } from '../../../shared/services/requests/financas/contas-receber-bulk-alterar-forma-recebimento.request';
import { MarcarPerdaContasReceberRequest } from '../../../shared/services/requests/financas/marcar-perda-contas-receber.request';
import { ReverterPerdaContasReceberRequest } from '../../../shared/services/requests/financas/reverter-perda-contas-receber.request';
import { TipoProcessamentoRecorrenciaEnum } from '../../../shared/enums/financas/tipo-processamento-recorrencia.enum';
import { UtilService } from '../../../shared/services/util.service';
import { CobrancaAtivoInfoItem } from '../../../shared/services/responses/financas/cobranca-ativo-info.response';
import { EstornoPixInfoResponse } from '../../../shared/services/responses/financas/estorno-pix-info.response';
import { ContasReceberBulkDeleteResponse } from '../../../shared/services/responses/financas/contas-receber-bulk-delete.response';

@Component({
    selector: 'app-contas-receber-lista',
    standalone: true,
    imports: [
        CommonModule,
        HeaderComponent,
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatTableModule,
        MatCheckboxModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatBadgeModule,
        MatTooltipModule,
        MatSelectModule,
        EmptyListComponent,
        LoadingBoxDefaultListComponent,
        SelectPesquisavelComponent,
        RouterModule,
        AbntPipe,
        MatDatepickerModule,
        MatNativeDateModule,
        UiTagComponent
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
        { provide: DateAdapter, useClass: CustomDateAdapter }
    ],
    templateUrl: './contas-receber-lista.component.html',
    styleUrls: ['./contas-receber-lista.component.css'],
})
export class ContasReceberListaComponent implements OnInit, OnDestroy {

    // Enums
    public moduloEnum = ModuloEnum.Financas;
    public funcionalidadeEnum = FuncionalidadeEnum.Financas_Contas_Receber;
    public _refinamentoEnum = ContasReceberRefinamentoEnum;
    public _statusContasReceberEnum = StatusContasReceberEnum;

    // Form
    public model: FormGroup;
    public filtroRefinar: number | null = null;

    // Loading
    public _isLoading: boolean = false;
    public gerandoCobrancaMap: Map<number, boolean> = new Map();

    // Destroy subject for unsubscribing
    private _destroy$ = new Subject<void>();

    // Dados e Paginação
    public _response: ContasReceberGetAllResponse | undefined;
    public _dataSource = new MatTableDataSource<ContasReceberGridItemStruct>();
    public _paginaAtual: number = 0;
    public _ultimaPagina: boolean = false;

    // Totais rodapé
    public _totalVencidos: number = 0;
    public _totalVencemHoje: number = 0;
    public _totalAVencer: number = 0;
    public _totalRecebidos: number = 0;
    public _totalPeriodo: number = 0;
    public _quantidadeLancamentos: number = 0;
    public _ocultarValores: boolean = false;

    // Mobile drawer state
    public isMobileDrawerOpen: boolean = false;

    // Seleção
    public selection = new SelectionModel<ContasReceberGridItemStruct>(true, []);

    // Colunas
    public displayedColumns: string[] = [];
    public todosCampos: ColunaConfiguracao[] = [
        { def: 'select', label: 'Seleção', visible: true, fixed: true, pinnedStart: true },
        { def: 'cliente', label: 'Cliente', visible: true, fixed: false },
        { def: 'descricao', label: 'Descrição', visible: true, fixed: false },
        { def: 'numeroDocumento', label: 'Nº documento', visible: true, fixed: false },
        { def: 'categoria', label: 'Categoria', visible: false, fixed: false },
        { def: 'formaRecebimento', label: 'Forma de Recebimento', visible: false, fixed: false },
        { def: 'dataEmissao', label: 'Emissão', visible: false, fixed: false },
        { def: 'valor', label: 'Valor', visible: true, fixed: false },
        { def: 'recebido', label: 'Recebido', visible: true, fixed: false },
        { def: 'aReceber', label: 'A Receber', visible: true, fixed: false },
        { def: 'taxaIntermediador', label: 'Taxa/tarifa interm. (prev.)', visible: false, fixed: false },
        { def: 'vencimento', label: 'Vencimento', visible: true, fixed: false },
        { def: 'tags', label: 'Tags', visible: true, fixed: false },
        { def: 'situacao', label: 'Situação', visible: true, fixed: false },
        { def: 'boleto', label: 'Boleto', visible: true, fixed: false },
        { def: 'actions', label: 'Ações', visible: true, fixed: true, pinnedEnd: true },
    ];

    // Listas para filtros avançados
    public listaCategoria: any[] = [];
    public listaTags: any[] = [];
    public listaStatus: any[] = [];
    public listaFormaRecebimento: any[] = [];
    public listaContasFinanceiras: any[] = [];
    public listaCentrosCusto: any[] = [];

    // Sentinela usado no filtro de Situação para o pseudo-status "Vencido"
    // (Em Aberto ou Recebido Parcialmente com vencimento < hoje — não existe como status real).
    public readonly ID_STATUS_VENCIDO = -1;

    public get listaSituacaoFiltro(): any[] {
        return [...this.listaStatus, { idStatusContasReceber: this.ID_STATUS_VENCIDO, descricao: 'Vencido' }];
    }

    // Seletor de periodo
    public periodoSelecionado: PeriodoContasReceberEnum = PeriodoContasReceberEnum.DoMes;
    public PeriodoContasReceberEnum = PeriodoContasReceberEnum;
    public limiteMeses = 12;

    // Último estado de período aplicado
    private periodoSelecionadoAplicado: PeriodoContasReceberEnum = PeriodoContasReceberEnum.DoMes;
    private periodoIntervaloDeAplicado: Date | null = null;
    private periodoIntervaloAteAplicado: Date | null = null;
    private periodoMenuFoiAplicado = false;

    @ViewChild('periodoMenuTrigger') periodoMenuTrigger?: MatMenuTrigger;

    constructor(
        private formBuilder: FormBuilder,
        private contasReceberService: ContasReceberService,
        private alertService: AlertService,
        private dialog: MatDialog,
        private pessoaLookupService: PessoaLookupService,
        private utilService: UtilService,
        private router: Router,
    ) { }

    ngOnInit(): void {
        this.carregarLookups();

        this.model = this.formBuilder.group({
            pesquisa: [''],
            dataDe: [, Validators.required],
            dataAte: [, Validators.required],
            periodoSelecionado: [PeriodoContasReceberEnum.DoMes],
            // Filtros avançados
            idStatus: [null],
            idCategoria: [null],
            idFormaRecebimento: [null],
            tags: [[]],
        }, {
            validators: LimitDateValidator.rangeLimit(this.limiteMeses)
        });
        this.calcularDatasParaPeriodo(PeriodoContasReceberEnum.DoMes);
        this.atualizarColunasVisiveis();
        this.loadFilters();
        this.salvarPeriodoAplicado();
        this.pesquisar();
    }

    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
        this.utilService.salvarFiltro(this.moduloEnum, this.funcionalidadeEnum, this.model, ['/financas/contas-receber/cadastrar', '/financas/contas-receber/parcela']);
    }

    private loadFilters(): void {
        const filtroSalvo = this.utilService.obterFiltro(this.moduloEnum, this.funcionalidadeEnum);
        if (filtroSalvo) {
            this.model.patchValue(filtroSalvo);
            if (filtroSalvo.periodoSelecionado != null) {
                this.periodoSelecionado = filtroSalvo.periodoSelecionado;
            }
        }
    }

    // --- Colunas configuráveis ---

    private atualizarColunasVisiveis(): void {
        this.displayedColumns = this.todosCampos
            .filter(c => c.visible)
            .map(c => c.def);
    }

    public configurarColunas(): void {
        const dialogRef = this.dialog.open(ConfiguracaoColunasModalComponent, {
            maxWidth: '700px',
            data: { colunas: this.todosCampos }
        });

        dialogRef.afterClosed().subscribe((result: ColunaConfiguracao[]) => {
            if (result) {
                this.todosCampos = result;
                this.atualizarColunasVisiveis();
            }
        });
    }

    // --- Lookups ---

    private carregarLookups(): void {
        this.contasReceberService.getLookups().subscribe({
            next: (res) => {
                if (res.isError) {
                    this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
                    return;
                }

                this.listaTags = res.tags;
                this.listaCategoria = res.categoriasFinanceiras;
                this.listaStatus = res.statusContasReceber;
                this.listaFormaRecebimento = res.formasRecebimento;
                this.listaContasFinanceiras = res.contasFinanceiras;
                this.listaCentrosCusto = res.centrosCusto;
            },
            error: (err) => {
                this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
            }
        });
    }

    // --- Pesquisa e Paginação ---

    public pesquisar(): void {
        if (this._isLoading) return;
        this._isLoading = true;

        const request = this.buildRequest();

        this.contasReceberService.getAll(request, this._paginaAtual).subscribe({
            next: (response: ContasReceberGetAllResponse) => {
                if (response.isError) {
                    this._isLoading = false;
                    this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
                    return;
                }

                if (!response.itens || response.itens.length === 0) {
                    this._ultimaPagina = true;
                }

                if (!this._response) {
                    this._response = response;
                } else {
                    this._response.itens.push(...response.itens);
                }

                // Atualizar totais do rodapé (sempre vem do servidor)
                this._totalVencidos = response.totalVencidos;
                this._totalVencemHoje = response.totalVencemHoje;
                this._totalAVencer = response.totalAVencer;
                this._totalRecebidos = response.totalRecebidos;
                this._totalPeriodo = response.totalPeriodo;
                this._quantidadeLancamentos = response.quantidadeLancamentos;

                if (response.itens.length === 0) {
                    this._ultimaPagina = true;
                }

                this.carregarNomesClientes(response.itens);
            },
            error: (err) => {
                this._isLoading = false;
                this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
            }
        });
    }

    private carregarNomesClientes(itensNovos: ContasReceberGridItemStruct[]): void {
        const ids = itensNovos
            .map(i => i.idCliente)
            .filter((id, index, self) => id != null && self.indexOf(id) === index) as number[];

        if (ids.length === 0) {
            this._isLoading = false;
            this.atualizaDataSourceNomes();
            return;
        }

        const req = new ListPessoaIdsRequest();
        req.listIdPessoa = ids;

        this.pessoaLookupService.getListPessoaIds(req).subscribe({
            next: (res) => {
                this._isLoading = false;
                if (res.isError) {
                    this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
                    return;
                }

                const dictPessoas = new Map(res.listaPessoa.map(p => [p.idPessoa, p.nome || p.nomeFantasia]));
                itensNovos.forEach(item => {
                    if (item.idCliente && dictPessoas.has(item.idCliente)) {
                        item.cliente = dictPessoas.get(item.idCliente)!;
                    }
                });

                this.atualizaDataSourceNomes();
            },
            error: () => {
                this._isLoading = false;
                this.atualizaDataSourceNomes(); // Sempre atualiza o grid no final
            }
        });
    }

    private atualizaDataSourceNomes(): void {
        if (!this._response) return;
        this._dataSource.data = [...this._response.itens];
    }

    public clickPesquisar(): void {
        this._paginaAtual = 0;
        this._response = undefined;
        this._dataSource.data = [];
        this._ultimaPagina = false;
        this.selection.clear();
        this.pesquisar();
    }

    public aplicarFiltros(): void {
        this.clickPesquisar();
    }

    public proximaPagina(): void {
        this._paginaAtual++;
        this.pesquisar();
    }

    public limparFiltros(): void {
        const hoje = new Date();
        const trintaDiasAtras = new Date();
        trintaDiasAtras.setDate(hoje.getDate() - 30);

        this.model.patchValue({
            pesquisa: '',
            idStatus: null,
            idCategoria: null,
            idFormaRecebimento: null,
            tags: [],
            dataDe: trintaDiasAtras,
            dataAte: hoje,
            periodoSelecionado: PeriodoContasReceberEnum.Ultimos30Dias,
        });
        this.filtroRefinar = null;
        this.periodoSelecionado = PeriodoContasReceberEnum.Ultimos30Dias;
        this.salvarPeriodoAplicado();
        this.clickPesquisar();
    }

    private buildRequest(): ContasReceberGetAllRequest {
        const request = new ContasReceberGetAllRequest();
        const formValue = this.model.getRawValue();

        request.pesquisa = formValue.pesquisa || null;
        request.refinamento = this.filtroRefinar;
        if (formValue.idStatus === this.ID_STATUS_VENCIDO) {
            request.idStatus = null;
            request.somenteVencidos = true;
        } else {
            request.idStatus = formValue.idStatus || null;
            request.somenteVencidos = null;
        }
        request.idCategoria = formValue.idCategoria || null;
        request.idFormaRecebimento = formValue.idFormaRecebimento || null;
        request.tags = formValue.tags && formValue.tags.length > 0 ? formValue.tags : null;

        // Datas já estão no form, calculadas pelo período selecionado
        request.dataInicio = formValue.dataDe ? this.formatDate(new Date(formValue.dataDe)) : null;
        request.dataFim = formValue.dataAte ? this.formatDate(new Date(formValue.dataAte)) : null;

        return request;
    }

    // --- MÉTODOS DE PERÍODO ---

    private cloneDate(data: Date | null): Date | null {
        return data ? new Date(data) : null;
    }

    private salvarPeriodoAplicado(): void {
        this.periodoSelecionadoAplicado = this.periodoSelecionado;
        this.periodoIntervaloDeAplicado = this.cloneDate(this.model.get('dataDe')?.value);
        this.periodoIntervaloAteAplicado = this.cloneDate(this.model.get('dataAte')?.value);
        this.model.get('periodoSelecionado')?.setValue(this.periodoSelecionado, { emitEvent: false });
    }

    private restaurarPeriodoAplicado(): void {
        this.periodoSelecionado = this.periodoSelecionadoAplicado;
        this.model.patchValue({
            dataDe: this.cloneDate(this.periodoIntervaloDeAplicado),
            dataAte: this.cloneDate(this.periodoIntervaloAteAplicado),
        });
    }

    onDateInput(event: Event, controlName: 'dataDe' | 'dataAte'): void {
        MaskService.onDateInput(event, this.model.get(controlName));
    }

    prepararPeriodoIntervalo(): void {
        this.periodoMenuFoiAplicado = false;
    }

    cancelarPeriodoIntervalo(trigger?: MatMenuTrigger): void {
        this.restaurarPeriodoAplicado();
        this.periodoMenuFoiAplicado = true;
        const menuTrigger = trigger ?? this.periodoMenuTrigger;
        setTimeout(() => menuTrigger?.closeMenu());
    }

    onPeriodoMenuClosed(): void {
        if (!this.periodoMenuFoiAplicado) {
            this.restaurarPeriodoAplicado();
        }
    }

    get periodoLabel(): string {
        switch (this.periodoSelecionado) {
            case PeriodoContasReceberEnum.Hoje: return 'hoje';
            case PeriodoContasReceberEnum.DaSemana: return 'desta semana';
            case PeriodoContasReceberEnum.DoMes: return 'do mês';
            case PeriodoContasReceberEnum.Ultimos30Dias: return 'últimos 30 dias';
            case PeriodoContasReceberEnum.DoIntervalo: return 'do intervalo';
            default: return 'últimos 30 dias';
        }
    }

    selecionarPeriodo(periodo: PeriodoContasReceberEnum): void {
        this.periodoSelecionado = periodo;
        if (periodo !== PeriodoContasReceberEnum.DoIntervalo) {
            this.calcularDatasParaPeriodo(periodo);
        }
    }

    private calcularDatasParaPeriodo(periodo: PeriodoContasReceberEnum): void {
        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);
        let dataDe: Date;
        let dataAte: Date;

        switch (periodo) {
            case PeriodoContasReceberEnum.Hoje:
                dataDe = new Date(hoje);
                dataAte = new Date(hoje);
                break;
            case PeriodoContasReceberEnum.DaSemana: {
                dataDe = new Date(hoje);
                dataDe.setDate(hoje.getDate() - hoje.getDay());
                dataAte = new Date(dataDe);
                dataAte.setDate(dataDe.getDate() + 6);
                break;
            }
            case PeriodoContasReceberEnum.DoMes: {
                dataDe = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
                dataAte = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
                break;
            }
            case PeriodoContasReceberEnum.Ultimos30Dias:
            default: {
                dataDe = new Date(hoje);
                dataDe.setDate(hoje.getDate() - 30);
                dataAte = new Date(hoje);
                break;
            }
        }

        this.model.patchValue({ dataDe, dataAte });
    }

    aplicarPeriodo(trigger?: MatMenuTrigger): void {
        if (this.periodoSelecionado === PeriodoContasReceberEnum.DoIntervalo) {
            // Marca os campos como touched para exibir os erros do Angular
            this.model.get('dataDe')?.markAsTouched();
            this.model.get('dataAte')?.markAsTouched();

            // Checa erros específicos do LimitDateValidator ANTES do genérico,
            // pois o validator seta erros diretamente no control dataAte (tornando-o invalid)
            if (this.model.get('dataAte')?.hasError('dataInvalida')) {
                this.alertService.show('Atenção', 'A data final não pode ser menor que a data inicial.', AlertType.warning);
                return;
            }
            if (this.model.get('dataAte')?.hasError('intervaloExcedido')) {
                this.alertService.show('Atenção', `O intervalo máximo permitido é de ${this.limiteMeses} meses.`, AlertType.warning);
                return;
            }
            // Valida required (datas vazias)
            if (this.model.get('dataDe')?.hasError('required') || this.model.get('dataAte')?.hasError('required')) {
                this.alertService.show('Atenção', 'Preencha as duas datas do intervalo.', AlertType.warning);
                return;
            }
        }

        this.periodoMenuFoiAplicado = true;
        this.salvarPeriodoAplicado();
        this.clickPesquisar();
        const menuTrigger = trigger ?? this.periodoMenuTrigger;
        setTimeout(() => menuTrigger?.closeMenu());
    }

    private formatDate(date: Date): string {
        return date.toISOString().split('T')[0];
    }

    // --- Seleção ---

    public isAllSelected(): boolean {
        const numSelected = this.selection.selected.length;
        const numRows = this._dataSource.data.length;
        return numSelected === numRows;
    }

    public isAllSelectedEmAberto(): boolean {
        if (!this.selection || this.selection.selected.length === 0) return false;
        return this.selection.selected.every(item => item.idStatus === StatusContasReceberEnum.EmAberto);
    }

    public toggleAllRows(): void {
        if (this.isAllSelected()) {
            this.selection.clear();
        } else {
            this.selection.select(...this._dataSource.data);
        }
    }

    public checkboxLabel(row?: ContasReceberGridItemStruct): string {
        if (!row) return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.idContasReceberParcela}`;
    }

    // --- Filtros Avançados ---

    public get qtdFiltrosAvancados(): number {
        let count = 0;
        const formValue = this.model.getRawValue();

        if (formValue.idStatus) count++;
        if (formValue.idCategoria) count++;
        if (formValue.idFormaRecebimento) count++;
        if (formValue.tags && formValue.tags.length > 0) count++;

        return count;
    }

    // --- Helpers de Exibição ---

    public getSituacaoClass(idStatus: number): string {
        switch (idStatus) {
            case StatusContasReceberEnum.EmAberto: return 'badge-amarelo';
            case StatusContasReceberEnum.Recebido: return 'badge-verde';
            case StatusContasReceberEnum.Cancelada: return 'badge-vermelho';
            case StatusContasReceberEnum.RecebidoParcialmente: return 'badge-azul';
            case StatusContasReceberEnum.Perda: return 'badge-cinza';
            case StatusContasReceberEnum.PerdaParcial: return 'badge-cinza';
            default: return 'badge-amarelo';
        }
    }

    // Mesma regra do filtro "Vencido" (ID_STATUS_VENCIDO): Em Aberto ou Recebido Parcialmente com
    // vencimento no passado. A situação real da parcela (badge) não deixa isso visível na linha.
    public isVencido(row: ContasReceberGridItemStruct): boolean {
        if (row.idStatus !== StatusContasReceberEnum.EmAberto && row.idStatus !== StatusContasReceberEnum.RecebidoParcialmente) {
            return false;
        }
        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);
        return new Date(row.vencimento) < hoje;
    }

    public getBoletoClass(idStatusBoleto: number): string {
        switch (idStatusBoleto) {
            case StatusIntegracaoBoletoEnum.Registrado: return 'badge-verde';
            case StatusIntegracaoBoletoEnum.Pago: return 'badge-verde';
            case StatusIntegracaoBoletoEnum.Pendente: return 'badge-azul';
            case StatusIntegracaoBoletoEnum.Cancelado: return 'badge-cinza';
            case StatusIntegracaoBoletoEnum.Expirado: return 'badge-cinza';
            case StatusIntegracaoBoletoEnum.Falha: return 'badge-vermelho';
            case StatusIntegracaoBoletoEnum.Rejeitado: return 'badge-vermelho';
            default: return 'badge-cinza';
        }
    }

    public toggleOcultarValores(): void {
        this._ocultarValores = !this._ocultarValores;
    }

    public toggleGavetaMobile(): void {
        this.isMobileDrawerOpen = !this.isMobileDrawerOpen;
        if (this.isMobileDrawerOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    }

    public fecharGavetaMobile(): void {
        if (this.isMobileDrawerOpen) {
            this.isMobileDrawerOpen = false;
            document.body.style.overflow = '';
        }
    }

    public isAllSelectedCancelavel(): boolean {
        if (this.selection.selected.length === 0) return false;
        return this.selection.selected.every(s =>
            s.idStatus === StatusContasReceberEnum.EmAberto &&
            !s.isAgrupado &&
            !this.isOrigemDocumento(s) &&
            s.recebido === 0
        );
    }

    public isAllSelectedExcluivel(): boolean {
        if (this.selection.selected.length === 0) return false;
        return this.selection.selected.every(s =>
            (s.idStatus === StatusContasReceberEnum.EmAberto ||
                s.idStatus === StatusContasReceberEnum.Cancelada) &&
            !s.isAgrupado &&
            !this.isOrigemDocumento(s) &&
            s.recebido === 0 &&
            !this.temCobranca(s)
        );
    }

    /** Parcela com QUALQUER registro de cobrança (PIX/boleto, independente do status) não pode ser excluída — só cancelada. */
    public temCobranca(row: ContasReceberGridItemStruct): boolean {
        return row.idStatusBoleto != null || row.idStatusPix != null;
    }

    /** Só boletos REGISTRADOS no banco podem ser baixados manualmente. */
    public isBoletoBaixavel(row: ContasReceberGridItemStruct): boolean {
        return row.idStatusBoleto === StatusIntegracaoBoletoEnum.Registrado;
    }

    public isAllSelectedBoletoBaixavel(): boolean {
        return this.selection.selected.length > 0 &&
            this.selection.selected.some(s => this.isBoletoBaixavel(s));
    }

    public tooltipBaixarBoleto(row: ContasReceberGridItemStruct): string {
        if (!this.isBoletoBaixavel(row)) return 'Apenas boletos registrados no banco podem ser baixados';
        return '';
    }

    public isAllSelectedEditavel(): boolean {
        return this.selection.selected.length > 0 &&
            this.selection.selected.every(item => this.isEditavel(item));
    }

    /** Forma de recebimento, parcela e documento: além de editável, não pode ter sido gerado pelo pedido de venda. */
    public isAllSelectedEditavelPeloFinancas(): boolean {
        return this.selection.selected.length > 0 &&
            this.selection.selected.every(item => this.isEditavelPeloFinancas(item));
    }

    /**
     * Registro gerado pelo pedido de venda: valor, vencimento, forma, conta, cliente, competência, centro de custo
     * e descrição só mudam pelo pedido (categoria, tags, baixa, estorno e agrupamento continuam liberados aqui).
     */
    public isEditavelPeloFinancas(row: ContasReceberGridItemStruct): boolean {
        return this.isEditavel(row) && !this.isOrigemDocumento(row);
    }

    /** Gerado por um documento (pedido de venda ou NF-e de saída): só muda pelo documento. */
    public isOrigemDocumento(row: ContasReceberGridItemStruct): boolean {
        return !!row.idVenda || !!row.idNFeSaida;
    }

    public tooltipOrigemDocumento(row: ContasReceberGridItemStruct): string {
        const numero = row.numeroDocumento ? ` nº ${row.numeroDocumento}` : '';
        if (row.idNFeSaida) return `Gerado pela NF-e de saída${numero}: para alterar ou excluir, use "Excluir financeiro" na nota.`;
        return `Gerado pelo pedido de venda${numero}: altere ou exclua pelo menu Ações do pedido.`;
    }

    /** Seleção com registro gerado por documento: o motivo vem antes dos demais nos tooltips em lote. */
    private tooltipSelecaoComVenda(): string {
        if (this.selection.selected.some(r => !!r.idNFeSaida)) {
            return 'Há contas geradas pela NF-e de saída na seleção: para alterar ou excluir, use "Excluir financeiro" na nota.';
        }
        return this.selection.selected.some(r => !!r.idVenda)
            ? 'Há contas geradas pelo pedido de venda na seleção: altere ou exclua pelo menu Ações do pedido.'
            : '';
    }

    public isAllSelectedRecebivel(): boolean {
        return this.selection.selected.length > 0 &&
            this.selection.selected.every(item =>
                item.idStatus !== StatusContasReceberEnum.Cancelada &&
                item.idStatus !== StatusContasReceberEnum.Recebido
            );
    }

    public isAllSelectedAgrupavel(): boolean {
        const itens = this.selection.selected;
        if (itens.length < 2) return false;
        const primeiroCliente = itens[0].idCliente;
        return itens.every(item =>
            item.idStatus === StatusContasReceberEnum.EmAberto &&
            !item.isAgrupado &&
            item.recebido === 0 &&
            item.idCliente === primeiroCliente
        );
    }

    public isEditavel(row: ContasReceberGridItemStruct): boolean {
        return row.idStatus !== StatusContasReceberEnum.Cancelada &&
            !row.isAgrupado &&
            row.recebido === 0;
    }

    public isCancelavel(row: ContasReceberGridItemStruct): boolean {
        return row.idStatus === StatusContasReceberEnum.EmAberto &&
            !row.isAgrupado &&
            !this.isOrigemDocumento(row) &&
            row.recebido === 0;
    }

    public isExcluivel(row: ContasReceberGridItemStruct): boolean {
        return (row.idStatus === StatusContasReceberEnum.EmAberto ||
            row.idStatus === StatusContasReceberEnum.Cancelada) &&
            !this.isOrigemDocumento(row) &&
            !row.isAgrupado &&
            row.recebido === 0 &&
            !this.temCobranca(row);
    }

    public isDesagrupavel(row: ContasReceberGridItemStruct): boolean {
        return row.isAgrupado &&
            row.idStatus !== StatusContasReceberEnum.Recebido &&
            row.recebido === 0;
    }

    public isPerdavel(row: ContasReceberGridItemStruct): boolean {
        return (row.idStatus === StatusContasReceberEnum.EmAberto ||
            row.idStatus === StatusContasReceberEnum.RecebidoParcialmente) &&
            row.aReceber > 0;
    }

    public isReversivelPerda(row: ContasReceberGridItemStruct): boolean {
        return row.idStatus === StatusContasReceberEnum.Perda ||
            row.idStatus === StatusContasReceberEnum.PerdaParcial;
    }

    // --- Tooltips por linha ---

    public tooltipReceber(row: ContasReceberGridItemStruct): string {
        if (row.idStatus === StatusContasReceberEnum.Cancelada) return 'Conta cancelada não pode ser recebida';
        if (row.idStatus === StatusContasReceberEnum.Recebido) return 'Esta conta já foi totalmente recebida';
        if (row.idStatus === StatusContasReceberEnum.Perda) return 'Esta conta foi baixada como perda';
        if (row.idStatus === StatusContasReceberEnum.PerdaParcial) return 'Esta conta foi baixada como perda parcial';
        return '';
    }

    public tooltipEditar(row: ContasReceberGridItemStruct): string {
        if (row.idStatus === StatusContasReceberEnum.Cancelada) return 'Conta cancelada não pode ser editada';
        if (row.idStatus === StatusContasReceberEnum.Recebido) return 'Esta conta já foi totalmente recebida';
        if (row.idStatus === StatusContasReceberEnum.Perda) return 'Esta conta foi baixada como perda';
        if (row.idStatus === StatusContasReceberEnum.PerdaParcial) return 'Esta conta foi baixada como perda parcial';
        if (row.isAgrupado) return 'Conta agrupada não pode ser editada. Desfaça o agrupamento primeiro';
        if (row.recebido > 0) return 'Conta com recebimento não pode ser editada. Estorne o recebimento primeiro';
        return '';
    }

    public tooltipCancelar(row: ContasReceberGridItemStruct): string {
        if (this.isOrigemDocumento(row)) return this.tooltipOrigemDocumento(row);
        if (row.idStatus === StatusContasReceberEnum.Cancelada) return 'Esta conta já está cancelada';
        if (row.idStatus === StatusContasReceberEnum.Recebido) return 'Conta recebida não pode ser cancelada. Estorne o recebimento primeiro';
        if (row.idStatus === StatusContasReceberEnum.Perda) return 'Esta conta foi baixada como perda. Para cancelar a perda deve ser revertida.';
        if (row.idStatus === StatusContasReceberEnum.PerdaParcial) return 'Esta conta foi baixada como perda parcial. Para cancelar a perda deve ser revertida.';
        if (row.isAgrupado) return 'Conta agrupada não pode ser cancelada. Desfaça o agrupamento primeiro';
        if (row.idStatus === StatusContasReceberEnum.RecebidoParcialmente) return 'Conta com recebimento parcial não pode ser cancelada. Estorne o recebimento primeiro';
        return '';
    }

    public tooltipExcluir(row: ContasReceberGridItemStruct): string {
        if (this.isOrigemDocumento(row)) return this.tooltipOrigemDocumento(row);
        if (row.isAgrupado) return 'Conta agrupada não pode ser excluída. Desfaça o agrupamento primeiro';
        if (row.recebido > 0) return 'Conta com recebimento não pode ser excluída. Estorne o recebimento primeiro';
        if (row.idStatus !== StatusContasReceberEnum.EmAberto && row.idStatus !== StatusContasReceberEnum.Cancelada)
            return 'Somente contas em aberto ou canceladas podem ser excluídas';
        if (this.temCobranca(row))
            return 'Parcela com cobrança (PIX/boleto) associada não pode ser excluída — utilize o cancelamento';
        return '';
    }

    public tooltipDesagrupar(row: ContasReceberGridItemStruct): string {
        if (row.idStatus === StatusContasReceberEnum.Recebido) return 'Conta recebida não pode ser desagrupada. Estorne o recebimento primeiro';
        if (row.recebido > 0) return 'Conta com recebimento parcial não pode ser desagrupada. Estorne o recebimento primeiro';
        return '';
    }

    public tooltipEstorno(row: ContasReceberGridItemStruct): string {
        if (row.idStatus !== StatusContasReceberEnum.Recebido
            && row.idStatus !== StatusContasReceberEnum.RecebidoParcialmente
            && row.recebido <= 0)
            return 'Apenas contas com recebimento podem ser estornadas';
        if (row.idStatus === StatusContasReceberEnum.Perda || row.idStatus === StatusContasReceberEnum.PerdaParcial)
            return 'Conta com perda não pode ser estornada. Reverter perda primeiro';
        return '';
    }

    public tooltipPerda(row: ContasReceberGridItemStruct): string {
        if (row.idStatus === StatusContasReceberEnum.Perda || row.idStatus === StatusContasReceberEnum.PerdaParcial)
            return 'Esta conta já foi baixada como perda';
        if (row.idStatus === StatusContasReceberEnum.Cancelada) return 'Conta cancelada não pode ser marcada como perda';
        if (row.idStatus === StatusContasReceberEnum.Recebido) return 'Esta conta já foi totalmente recebida';
        if (row.aReceber <= 0) return 'Não há saldo a receber para marcar como perda';
        return '';
    }

    public tooltipReverterPerda(row: ContasReceberGridItemStruct): string {
        if (row.idStatus !== StatusContasReceberEnum.Perda && row.idStatus !== StatusContasReceberEnum.PerdaParcial)
            return 'Esta conta não está marcada como perda';
        return '';
    }

    // --- Tooltips em massa ---

    public tooltipBulkReceber(): string {
        if (!this.selection.hasValue()) return '';
        const items = this.selection.selected;
        if (items.some(r => r.idStatus === StatusContasReceberEnum.Cancelada))
            return 'Há contas canceladas na seleção';
        if (items.some(r => r.idStatus === StatusContasReceberEnum.Recebido))
            return 'Há contas já recebidas na seleção';
        return '';
    }

    public tooltipBulkEditar(): string {
        if (!this.selection.hasValue()) return '';
        const items = this.selection.selected;
        if (items.some(r => r.idStatus === StatusContasReceberEnum.Cancelada))
            return 'Há contas canceladas na seleção';
        if (items.some(r => r.idStatus === StatusContasReceberEnum.Recebido || r.recebido > 0))
            return 'Há contas recebidas na seleção. Estorne o recebimento primeiro';
        if (items.some(r => r.isAgrupado))
            return 'Há contas agrupadas na seleção. Desfaça o agrupamento primeiro';
        return '';
    }

    /** Forma de recebimento e edição em massa: registro da venda só muda pelo pedido. */
    public tooltipBulkEditarPeloFinancas(): string {
        if (!this.selection.hasValue()) return '';
        return this.tooltipSelecaoComVenda() || this.tooltipBulkEditar();
    }

    public tooltipBulkCancelar(): string {
        if (!this.selection.hasValue()) return '';
        const venda = this.tooltipSelecaoComVenda();
        if (venda) return venda;
        const items = this.selection.selected;
        if (items.some(r => r.idStatus === StatusContasReceberEnum.Recebido || r.recebido > 0))
            return 'Há contas recebidas na seleção. Estorne o recebimento primeiro';
        if (items.some(r => r.idStatus === StatusContasReceberEnum.Cancelada))
            return 'Há contas já canceladas na seleção';
        if (items.some(r => r.isAgrupado))
            return 'Há contas agrupadas na seleção. Desfaça o agrupamento primeiro';
        return '';
    }

    public tooltipBulkAgrupar(): string {
        if (!this.selection.hasValue()) return '';
        const items = this.selection.selected;
        if (items.length < 2) return 'Selecione ao menos 2 contas para agrupar';
        if (items.some(r => r.idStatus !== StatusContasReceberEnum.EmAberto))
            return 'Todas as contas devem estar em aberto para agrupar';
        if (items.some(r => r.isAgrupado))
            return 'Há contas já agrupadas na seleção';
        if (items.some(r => r.recebido > 0))
            return 'Há contas com recebimento na seleção. Estorne primeiro';
        const clienteIds = new Set(items.map(r => r.idCliente));
        if (clienteIds.size > 1) return 'Todas as contas devem ser do mesmo cliente';
        return '';
    }

    public tooltipBulkExcluir(): string {
        if (!this.selection.hasValue()) return '';
        const venda = this.tooltipSelecaoComVenda();
        if (venda) return venda;
        const items = this.selection.selected;
        if (items.some(r => r.isAgrupado))
            return 'Há contas agrupadas na seleção. Desfaça o agrupamento primeiro';
        if (items.some(r => r.recebido > 0))
            return 'Há contas com recebimento na seleção. Estorne primeiro';
        if (items.some(r => r.idStatus !== StatusContasReceberEnum.EmAberto && r.idStatus !== StatusContasReceberEnum.Cancelada))
            return 'Somente contas em aberto ou canceladas podem ser excluídas';
        if (items.some(r => this.temCobranca(r)))
            return 'Há parcelas com cobranças (PIX/boleto) associadas na seleção — elas só podem ser canceladas';
        return '';
    }

    // --- Impressão ---

    public abrirImpressao(): void {
        const request = this.buildRequest();
        this.dialog.open(ImpressaoContasReceberDialogComponent, {
            width: '95vw',
            maxWidth: '1200px',
            height: '90vh',
            data: { filtros: request } as ImpressaoContasReceberDialogData
        });
    }

    // --- Exportação ---

    public exportarContasReceber(): void {
        const formValue = this.model.getRawValue();
        const filtrosMapeados: FiltroExtracao[] = [];

        if (formValue.pesquisa) {
            filtrosMapeados.push({ label: 'Pesquisa', formControlName: 'pesquisa', valor: formValue.pesquisa });
        }

        // Período — sempre terá datas
        const dataDe = formValue.dataDe ? new Date(formValue.dataDe) : null;
        const dataAte = formValue.dataAte ? new Date(formValue.dataAte) : null;
        const periodoLabel = this.periodoLabel;

        if (dataDe) {
            filtrosMapeados.push({
                label: 'Data Início',
                formControlName: 'dataInicio',
                valor: this.formatDate(dataDe),
                valorExibicao: dataDe.toLocaleDateString('pt-BR')
            });
        }
        if (dataAte) {
            filtrosMapeados.push({
                label: 'Data Fim',
                formControlName: 'dataFim',
                valor: this.formatDate(dataAte),
                valorExibicao: dataAte.toLocaleDateString('pt-BR')
            });
        }
        filtrosMapeados.push({
            label: 'Período',
            formControlName: 'periodoOpcao',
            valor: periodoLabel,
            valorExibicao: periodoLabel
        });

        if (formValue.idStatus) {
            const statusObj = this.listaSituacaoFiltro.find(s => s.idStatusContasReceber === formValue.idStatus);
            filtrosMapeados.push({ label: 'Situação', formControlName: 'idStatus', valor: formValue.idStatus, valorExibicao: statusObj ? statusObj.descricao : formValue.idStatus });
        }

        if (formValue.idCategoria) {
            const categoria = this.listaCategoria.find(c => c.idCategoriaFinanceira === formValue.idCategoria);
            filtrosMapeados.push({ label: 'Categoria', formControlName: 'idCategoria', valor: formValue.idCategoria, valorExibicao: categoria ? categoria.descricao : formValue.idCategoria });
        }

        if (formValue.idFormaRecebimento) {
            const formaPagt = this.listaFormaRecebimento.find(f => f.idFormaRecebimento === formValue.idFormaRecebimento);
            filtrosMapeados.push({ label: 'Forma de Recebimento', formControlName: 'idFormaRecebimento', valor: formValue.idFormaRecebimento, valorExibicao: formaPagt ? formaPagt.descricao : formValue.idFormaRecebimento });
        }

        if (formValue.tags && formValue.tags.length > 0) {
            const tags = formValue.tags.map((id: number) => {
                const tag = this.listaTags.find(t => t.idTagContasReceber === id);
                return tag ? tag.descricao : id;
            }).join(', ');
            filtrosMapeados.push({ label: 'Tags', formControlName: 'tags', valor: formValue.tags, valorExibicao: tags });
        }

        const dialogData: ExtracaoDadosData = {
            titulo: 'Exportar Contas a Receber',
            tipoExtracao: TipoExtracaoEnum.ContasReceberCSV,
            origemPedidoExportacao: OrigemPedidoExportacaoEnum.FinancasContasReceber,
            filtros: filtrosMapeados,
            possuiAutomacao: false,
        };

        this.dialog.open(ExtracaoDadosModalComponent, {
            data: dialogData,
            panelClass: 'extracao-dados-panel',
            disableClose: true
        });
    }

    // --- Ações (mocks) ---

    public acoesNaoImplementadas(): void {
        this.alertService.show('Info', 'Esta ação será implementada em breve.', AlertType.warning);
    }

    public abrirRecebimento(contas: ContasReceberGridItemStruct[]): void {
        if (!contas || contas.length === 0) return;

        const invalidas = contas.filter(c =>
            c.idStatus !== StatusContasReceberEnum.EmAberto
            && c.idStatus !== StatusContasReceberEnum.RecebidoParcialmente);
        if (invalidas.length > 0) {
            this.alertService.show('Atenção', 'Apenas contas Em Aberto ou Recebidas Parcialmente podem ser recebidas. Desmarque contas que já estão Canceladas ou Recebidas.', AlertType.warning);
            return;
        }

        // Validação: só bloqueia quando houver mais de uma conta financeira selecionada distinta
        if (contas.length > 1) {
            const contasUnicas = new Set(
                contas
                    .map(c => c.idContaFinanceira)
                    .filter((id): id is number => id !== null && id !== undefined)
            );

            if (contasUnicas.size > 1) {
                this.alertService.show('Atenção', 'As contas selecionadas devem ter a mesma conta financeira.', AlertType.warning);
                return;
            }
        }

        const dialogRef = this.dialog.open(ReceberContasDialogComponent, {
            maxWidth: '90vw',
            maxHeight: '90vh',
            disableClose: true,
            data: {
                parcelas: contas,
                listaCategorias: this.listaCategoria,
                listaContasFinanceiras: this.listaContasFinanceiras
            } as ReceberContasDialogData
        });

        dialogRef.afterClosed().subscribe((res) => {
            if (res) {
                if (res.avisoDescricao) this.mostrarAvisoCobranca(res.avisoDescricao);
                this.clickPesquisar();
            }
        });
    }

    public abrirImportacao(): void {
        const dialogRef = this.dialog.open(ImportarContasReceberDialogComponent, {
            maxWidth: '90vw',
            maxHeight: '90vh',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.clickPesquisar();
            }
        });
    }

    // --- Helpers PIX ---

    /**
     * Consulta cobranças (PIX e boleto) ativas das parcelas via endpoints em lote (aceitam 1 ou N),
     * monta o aviso adaptando o texto à quantidade e abre o modal de confirmação.
     */
    private abrirConfirmCobrancaInfo(idsParcelas: number[], title: string, msg: string, labelConfirm: string, labelClose: string, callback: () => void): void {
        this.contasReceberService.getCobrancaAtivoInfo(idsParcelas)
            .pipe(catchError(() => of(null)), takeUntil(this._destroy$))
            .subscribe((res) => {
                const aviso = this.montarAvisoCobranca(res?.itens ?? [], idsParcelas.length === 1);
                this._abrirConfirmModal(title, msg + aviso, labelConfirm, labelClose, callback);
            });
    }

    /**
     * Mensagem padrão de cobrança ativa (única para todos os fluxos): discrimina PIX, boleto pago,
     * baixa automática (banco com WS) e baixa manual (banco sem WS). Vazia quando não há cobrança a tratar.
     */
    private montarAvisoCobranca(itens: CobrancaAtivoInfoItem[], unico: boolean): string {
        const temPix = itens.some(i => i.temPixAtivo);
        const algumBoletoPago = itens.some(i => i.boletoJaPago);
        const temBoletoBaixaAutomatica = itens.some(i => i.temBoletoAtivo && i.boletoSuportaBaixaAutomatica);
        const temBoletoBaixaManual = itens.some(i => i.temBoletoAtivo && !i.boletoSuportaBaixaAutomatica);
        let aviso = '';
        if (temPix)
            aviso += unico
                ? `<br><br><strong>Atenção:</strong> Existe um Pix ativo para esta parcela. Ao prosseguir, essa cobrança Pix será cancelada.`
                : `<br><br><strong>Atenção:</strong> Uma ou mais parcelas selecionadas possuem Pix ativos. Ao prosseguir, todas essas cobranças Pix serão canceladas.`;
        if (algumBoletoPago)
            aviso += unico
                ? `<br><br><strong>Atenção:</strong> Esta parcela possui um boleto já pago — ele não será cancelado; eventual devolução deve ser feita manualmente.`
                : `<br><br><strong>Atenção:</strong> Uma ou mais parcelas possuem boleto já pago — eles não serão cancelados; eventual devolução é manual.`;
        if (temBoletoBaixaAutomatica)
            aviso += unico
                ? `<br><br><strong>Atenção:</strong> Existe um boleto ativo para esta parcela. Ao prosseguir, a baixa será solicitada ao banco automaticamente (boletos ainda em processamento serão baixados assim que o registro for confirmado).`
                : `<br><br><strong>Atenção:</strong> Uma ou mais parcelas possuem boletos ativos. Ao prosseguir, a baixa será solicitada ao banco automaticamente (boletos ainda em processamento serão baixados assim que o registro for confirmado).`;
        if (temBoletoBaixaManual)
            aviso += unico
                ? `<br><br><strong>Atenção:</strong> O banco deste boleto <strong>não permite baixa automática</strong> — você precisará baixá-lo manualmente no portal do banco.`
                : `<br><br><strong>Atenção:</strong> Há boletos de bancos que <strong>não permitem baixa automática</strong> — você precisará baixá-los manualmente no portal do banco.`;
        if (aviso)
            aviso += `<br><br>Deseja realmente continuar?`;
        return aviso;
    }

    private _abrirConfirmModal(title: string, innerHtml: string, labelConfirm: string, labelClose: string, callback: () => void): void {
        setTimeout(() => {
            this.dialog.open(ConfirmModalComponent, {
                width: '440px',
                data: { title, innerHtml, buttonConfirm: labelConfirm, buttonClose: labelClose }
            }).afterClosed().subscribe(res => { if (res?.confirm) callback(); });
        }, 0);
    }

    private mostrarAvisoCobranca(avisoDescricao: string): void {
        const html = avisoDescricao.split(' | ').join('<br><br>');
        this.dialog.open(ConfirmModalComponent, {
            data: { title: 'Atenção — Cobrança', innerHtml: html, buttonClose: 'Entendi' }
        });
    }

    // --- Deletar e Cancelar Lançamentos ---

    // Exclusão NÃO cancela cobranças: parcela com cobrança (PIX/boleto) associada não é excluível
    // (botão desabilitado; o backend valida e nomeia as parcelas bloqueadas — só cancelamento é permitido).
    public excluirContas(contas: ContasReceberGridItemStruct[] | undefined = undefined): void {
        const itens = contas || this.selection.selected;
        if (!itens || itens.length === 0) return;

        if (itens.length === 1 && itens[0].isRecorrente) {
            setTimeout(() => {
                const dialogRef = this.dialog.open(ConfirmAcaoRecorrenteDialogComponent, {
                    width: '500px',
                    data: {
                        title: 'Atenção, Conta Recorrente!',
                        description: 'Você está prestes a excluir uma Conta a Receber que possui recorrência. O que deseja fazer com as contas em aberto vinculadas a essa conta?',
                        buttonConfirm: 'Excluir',
                        buttonClose: 'Cancelar',
                        confirmColor: 'warn'
                    }
                });

                dialogRef.afterClosed().subscribe((res) => {
                    if (!res?.confirm) return;
                    this.enviarExclusao(itens, res.tipoProcessamento);
                });
            }, 0);
        } else {
            const isLote = itens.length > 1;
            const msg = isLote
                ? `Você está prestes a excluir ${itens.length} Contas a Receber. Tem certeza disso?`
                : `Você está prestes a excluir a Conta a Receber "${itens[0].descricao}". Tem certeza disso?`;

            this._abrirConfirmModal(
                'Atenção, Exclusão de Conta!', msg, 'Excluir', 'Cancelar',
                () => this.enviarExclusao(itens, TipoProcessamentoRecorrenciaEnum.ApenasEsta)
            );
        }
    }

    private enviarExclusao(itens: ContasReceberGridItemStruct[], tipoProcessamento: TipoProcessamentoRecorrenciaEnum): void {
        if (this._isLoading) return;
        this._isLoading = true;

        const request = new ContasReceberBulkRequest();
        request.idsParcelas = itens.map(i => i.idContasReceberParcela);
        request.tipoProcessamentoRecorrencia = tipoProcessamento;

        this.contasReceberService.bulkDelete(request).subscribe({
            next: (res: ContasReceberBulkDeleteResponse) => {
                this._isLoading = false;
                if (res.isError) {
                    this.alertService.show('Atenção', res.errorDescription, AlertType.warning);
                    return;
                }
                this.alertService.show('Sucesso', "Contas excluídas com sucesso!", AlertType.success);
                if (res.avisoDescricao) this.mostrarAvisoCobranca(res.avisoDescricao);
                this.clickPesquisar();
            },
            error: (err) => {
                this._isLoading = false;
                this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
            }
        });
    }

    public cancelarContas(contas: ContasReceberGridItemStruct[] | undefined = undefined): void {
        const itens = contas || this.selection.selected;
        if (!itens || itens.length === 0) return;

        if (itens.length === 1 && itens[0].isRecorrente) {
            setTimeout(() => {
                const dialogRef = this.dialog.open(ConfirmAcaoRecorrenteDialogComponent, {
                    data: {
                        title: 'Atenção, Conta Recorrente!',
                        description: 'Você está prestes a cancelar uma Conta a Receber que possui recorrência. O que deseja fazer com as contas em aberto vinculadas a essa conta?',
                        buttonConfirm: 'Confirmar cancelamento',
                        buttonClose: 'Voltar',
                    }
                });

                dialogRef.afterClosed().subscribe((res) => {
                    if (!res?.confirm) return;
                    this.contasReceberService.getCobrancaAtivoInfo([itens[0].idContasReceberParcela])
                        .pipe(catchError(() => of(null)), takeUntil(this._destroy$))
                        .subscribe((resInfo) => {
                            const info = resInfo?.itens?.[0];
                            let aviso = '';
                            if (info?.temPixAtivo)
                                aviso += 'Esta parcela possui um Pix ativo que será cancelado. Caso as parcelas seguintes da mesma recorrência também tenham Pix gerados, o sistema fará o cancelamento automático de todos eles.';
                            if (info?.boletoJaPago)
                                aviso += (aviso ? '<br><br>' : '') + 'Esta parcela possui um boleto já pago — ele não será cancelado; eventual devolução é manual.';
                            else if (info?.temBoletoAtivo)
                                aviso += (aviso ? '<br><br>' : '') + 'Esta parcela possui um boleto ativo que será cancelado/baixado — o mesmo vale para as parcelas seguintes da recorrência.';

                            if (aviso) {
                                this._abrirConfirmModal(
                                    'Atenção — Cobrança ativa', aviso, 'Prosseguir', 'Voltar',
                                    () => this.enviarCancelamento(itens, res.tipoProcessamento)
                                );
                            } else {
                                this.enviarCancelamento(itens, res.tipoProcessamento);
                            }
                        });
                });
            }, 0);
        } else {
            const isLote = itens.length > 1;
            const msg = isLote
                ? `Você está prestes a cancelar ${itens.length} Contas a Receber. Tem certeza disso?`
                : `Você está prestes a cancelar a Conta a Receber "${itens[0].descricao}". Tem certeza disso?`;

            this.abrirConfirmCobrancaInfo(
                itens.map(i => i.idContasReceberParcela),
                'Atenção, Cancelamento de Conta!', msg, 'Confirmar cancelamento', 'Voltar',
                () => this.enviarCancelamento(itens, TipoProcessamentoRecorrenciaEnum.ApenasEsta)
            );
        }
    }

    private enviarCancelamento(itens: ContasReceberGridItemStruct[], tipoProcessamento: TipoProcessamentoRecorrenciaEnum): void {
        if (this._isLoading) return;
        this._isLoading = true;

        const request = new ContasReceberBulkRequest();
        request.idsParcelas = itens.map(i => i.idContasReceberParcela);
        request.tipoProcessamentoRecorrencia = tipoProcessamento;

        this.contasReceberService.bulkCancelar(request).subscribe({
            next: (res) => {
                this._isLoading = false;
                if (res.isError) {
                    this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
                    return;
                }
                this.alertService.show('Sucesso', "Contas canceladas com sucesso!", AlertType.success);
                if (res.avisoDescricao) this.mostrarAvisoCobranca(res.avisoDescricao);
                this.clickPesquisar();
            },
            error: (err) => {
                this._isLoading = false;
                this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
            }
        });
    }

    // --- Estorno de Recebimento ---

    public estornarRecebimento(conta: ContasReceberGridItemStruct): void {
        if (!conta) return;

        this.contasReceberService.getEstornoPixInfo(conta.idContasReceberParcela).subscribe({
            next: (pixInfo: EstornoPixInfoResponse) => {
                let title: string;
                let description: string = '';
                let innerHtml: string | undefined;

                if (pixInfo.temPixPago) {
                    title = 'Atenção — Parcela recebida via PIX';
                    const endToEndInfo = pixInfo.endToEndIdPagamento
                        ? `<br><br><strong>ID PIX de referência:</strong> ${pixInfo.endToEndIdPagamento}<br>Utilize este código ao solicitar a devolução no seu banco.`
                        : '';
                    innerHtml = `Esta parcela foi recebida via PIX.<br><br>Caso deseje devolver o valor ao pagador, o estorno deverá ser feito <strong>manualmente pelo seu banco</strong>.${endToEndInfo}<br><br>Deseja prosseguir com o estorno contábil?`;
                } else if (pixInfo.temBoletoPago) {
                    title = 'Atenção — Parcela recebida via boleto';
                    innerHtml = `Esta parcela foi recebida via <strong>boleto</strong>.<br><br>O estorno contábil não devolve o valor ao pagador — caso deseje devolver, a devolução deverá ser feita <strong>manualmente pelo seu banco</strong>.<br><br>Deseja prosseguir com o estorno contábil?`;
                } else {
                    title = 'Atenção, Estorno de Recebimento!';
                    description = `Você está prestes a estornar o Recebimento da parcela "${conta.descricao || conta.idContasReceberParcela}". Todas as liquidações atreladas nela serão fisicamente apagadas, e o saldo das contas financeiras movimentadas será devolvido. Tem certeza disso?`;
                }

                const usaInnerHtml = pixInfo.temPixPago || pixInfo.temBoletoPago;
                this.dialog.open(ConfirmModalComponent, {
                    data: {
                        title,
                        description: usaInnerHtml ? undefined : description,
                        innerHtml: usaInnerHtml ? innerHtml : undefined,
                        buttonConfirm: 'Confirmar Estorno',
                        buttonClose: 'Voltar'
                    }
                }).afterClosed().subscribe((res) => {
                    if (res?.confirm) {
                        this.enviarEstorno(conta.idContasReceberParcela);
                    }
                });
            },
            error: () => {
                // On error, proceed with normal estorno flow (no PIX info available)
                this.dialog.open(ConfirmModalComponent, {
                    data: {
                        title: 'Atenção, Estorno de Recebimento!',
                        description: `Você está prestes a estornar o Recebimento da parcela "${conta.descricao || conta.idContasReceberParcela}". Todas as liquidações atreladas nela serão fisicamente apagadas, e o saldo das contas financeiras movimentadas será devolvido. Tem certeza disso?`,
                        buttonConfirm: 'Confirmar Estorno',
                        buttonClose: 'Voltar'
                    }
                }).afterClosed().subscribe((res) => {
                    if (res?.confirm) {
                        this.enviarEstorno(conta.idContasReceberParcela);
                    }
                });
            }
        });
    }

    private enviarEstorno(idContasReceberParcela: number): void {
        if (this._isLoading) return;
        this._isLoading = true;

        this.contasReceberService.estornarRecebimento(idContasReceberParcela).subscribe({
            next: (res) => {
                this._isLoading = false;
                if (res.isError) {
                    this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
                    return;
                }
                this.alertService.show('Sucesso', "Recebimento estornado com sucesso!", AlertType.success);
                this.clickPesquisar();
            },
            error: (err) => {
                this._isLoading = false;
                this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
            }
        });
    }

    // --- Baixa manual de boleto ---

    public baixarBoletos(contas: ContasReceberGridItemStruct[] | undefined = undefined): void {
        const selecionados = (contas || this.selection.selected);
        const itens = selecionados.filter(i => this.isBoletoBaixavel(i));
        if (!itens || itens.length === 0) {
            this.alertService.show('Aviso', 'Selecione ao menos um boleto registrado para baixar.', AlertType.warning);
            return;
        }

        // Só boletos Registrados são baixáveis — avisa quando há selecionados sem boleto registrado (ignorados).
        const ignorados = selecionados.length - itens.length;
        const avisoIgnorados = ignorados > 0
            ? `<br><br><small>${ignorados} item(ns) selecionado(s) sem boleto registrado foram ignorados.</small>`
            : '';

        const unico = itens.length === 1;
        const msg = (unico
            ? `Você está prestes a solicitar a baixa do boleto da parcela "${itens[0].descricao}". A parcela continuará em aberto.<br><br>Boletos de bancos que não permitem baixa automática precisarão ser baixados manualmente no portal do banco.`
            : `Você está prestes a solicitar a baixa de ${itens.length} boletos registrados. As parcelas continuarão em aberto.<br><br>Boletos de bancos que não permitem baixa automática precisarão ser baixados manualmente no portal do banco.`)
            + avisoIgnorados
            + '<br><br>Deseja continuar?';

        this._abrirConfirmModal('Baixar Boleto', msg, 'Solicitar baixa', 'Cancelar', () => {
            if (this._isLoading) return;
            this._isLoading = true;
            this.contasReceberService.solicitarBaixaBoletos(itens.map(i => i.idContasReceberParcela)).subscribe({
                next: (res) => {
                    this._isLoading = false;
                    if (res.isError) {
                        this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
                        return;
                    }
                    this.alertService.show('Sucesso', 'Baixa de boleto(s) solicitada.', AlertType.success);
                    if (res.avisoDescricao) this.mostrarAvisoCobranca(res.avisoDescricao);
                    this.clickPesquisar();
                },
                error: (err) => {
                    this._isLoading = false;
                    this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
                }
            });
        });
    }

    // --- Marcar como Perda / Reverter Perda ---

    public marcarComoPerda(row: ContasReceberGridItemStruct): void {
        const msg = `O valor restante de ${row.aReceber.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} será reconhecido como perda.<br><br>Isso significa que ele será removido do Contas a Receber e não será mais considerado como valor a receber ou em atraso.`;

        // Aviso prévio de cobrança ativa (PIX/boleto): marcar perda também cancela/baixa as cobranças
        this.abrirConfirmCobrancaInfo(
            [row.idContasReceberParcela],
            'Marcar como Perda', msg, 'Confirmar Perda', 'Cancelar',
            () => {
                if (this._isLoading) return;
                this._isLoading = true;
                const request = new MarcarPerdaContasReceberRequest();
                request.idContasReceberParcela = row.idContasReceberParcela;
                this.contasReceberService.marcarPerda(request).subscribe({
                    next: (response) => {
                        this._isLoading = false;
                        if (response.isError) {
                            this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
                            return;
                        }
                        this.alertService.show('Sucesso', 'Parcela marcada como perda com sucesso.', AlertType.success);
                        if (response.avisoDescricao) this.mostrarAvisoCobranca(response.avisoDescricao);
                        this.clickPesquisar();
                    },
                    error: (err) => {
                        this._isLoading = false;
                        this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
                    }
                });
            }
        );
    }

    public reverterPerda(row: ContasReceberGridItemStruct): void {
        const dialogRef = this.dialog.open(ConfirmModalComponent, {
            data: {
                title: 'Reverter Perda',
                description: 'Deseja reverter a baixa por perda desta parcela? O título será reaberto e voltará ao status anterior (Em Aberto ou Parcialmente Recebido).',
                buttonConfirm: 'Reverter Perda',
                buttonClose: 'Cancelar'
            }
        });

        dialogRef.afterClosed().subscribe((res) => {
            if (!res?.confirm) return;
            if (this._isLoading) return;
            this._isLoading = true;
            const request = new ReverterPerdaContasReceberRequest();
            request.idContasReceberParcela = row.idContasReceberParcela;
            this.contasReceberService.reverterPerda(request).subscribe({
                next: (response) => {
                    this._isLoading = false;
                    if (response.isError) {
                        this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
                        return;
                    }
                    this.alertService.show('Sucesso', 'Perda revertida com sucesso.', AlertType.success);
                    this.clickPesquisar();
                },
                error: (err) => {
                    this._isLoading = false;
                    this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
                }
            });
        });
    }

    // --- Alterar Tags em Massa ---

    public alterarTagsEmMassa(contas: ContasReceberGridItemStruct[] | undefined = undefined): void {
        const itens = contas || this.selection.selected;
        if (!itens || itens.length === 0) return;

        const idsTagsAtuais = itens
            .map(i => new Set((i.tags ?? []).map(t => t.id)))
            .reduce((acc, atual) => new Set([...acc].filter(id => atual.has(id))));

        const dialogData: AlterarTagsDialogData = {
            idsContasReceberParcela: itens.map(i => i.idContasReceberParcela),
            tags: this.listaTags,
            idsTagsAtuais: Array.from(idsTagsAtuais),
        };

        const dialogRef = this.dialog.open(AlterarTagsDialogComponent, {
            width: '480px',
            maxWidth: '95vw',
            maxHeight: '95vh',
            data: dialogData,
        });

        dialogRef.afterClosed().subscribe((res) => {
            if (res?.success) {
                this.clickPesquisar();
            }
        });
    }

    // --- Alterar Categoria em Massa ---

    public alterarCategoriaEmMassa(contas: ContasReceberGridItemStruct[] | undefined = undefined): void {
        const itens = contas || this.selection.selected;
        if (!itens || itens.length === 0) return;

        const dialogData: AlterarCategoriaDialogData = {
            idsContasReceberParcela: itens.map(i => i.idContasReceberParcela),
            categoriasFinanceiras: this.listaCategoria,
        };

        const dialogRef = this.dialog.open(AlterarCategoriaDialogComponent, {
            width: '480px',
            maxWidth: '95vw',
            disableClose: true,
            data: dialogData,
        });

        dialogRef.afterClosed().subscribe((sucesso: boolean) => {
            if (sucesso) {
                this.clickPesquisar();
            }
        });
    }

    // --- Edição em Massa ---

    public editarEmMassa(): void {
        const itens = this.selection.selected;
        if (!itens || itens.length === 0) return;

        const ids = itens.map(i => i.idContasReceberParcela);

        this.contasReceberService.getCobrancaAtivoInfo(ids)
            .pipe(catchError(() => of(null)), takeUntil(this._destroy$))
            .subscribe((resInfo) => {
                const aviso = this.montarAvisoCobranca(resInfo?.itens ?? [], ids.length === 1);
                if (aviso) {
                    this._abrirConfirmModal(
                        'Atenção — Cobrança ativa', aviso.replace(/^(<br><br>)+/, ''), 'Continuar', 'Cancelar',
                        () => this.abrirDialogEditarEmMassa(itens)
                    );
                } else {
                    this.abrirDialogEditarEmMassa(itens);
                }
            });
    }

    private abrirDialogEditarEmMassa(itens: ContasReceberGridItemStruct[]): void {
        const dialogData: EditarContasMassaDialogData = {
            idsContasReceberParcela: itens.map(i => i.idContasReceberParcela),
            categoriasFinanceiras: this.listaCategoria,
            contasFinanceiras: this.listaContasFinanceiras,
            centrosCusto: this.listaCentrosCusto,
        };

        const dialogRef = this.dialog.open(EditarContasMassaDialogComponent, {
            width: '820px',
            maxWidth: '95vw',
            maxHeight: '90vh',
            disableClose: true,
            data: dialogData,
        });

        dialogRef.afterClosed().subscribe((result: { sucesso: boolean; avisoDescricao?: string | null } | boolean) => {
            const sucesso = typeof result === 'boolean' ? result : result?.sucesso;
            if (sucesso) {
                if (typeof result === 'object' && result?.avisoDescricao) this.mostrarAvisoCobranca(result.avisoDescricao);
                this.clickPesquisar();
            }
        });
    }

    // --- Alterar Forma de Recebimento em Massa ---

    public alterarFormaRecebimento(contas: ContasReceberGridItemStruct[] | undefined = undefined): void {
        const itens = contas || this.selection.selected;
        if (!itens || itens.length === 0) return;

        const dialogRef = this.dialog.open(AlterarFormaRecebimentoDialogComponent, {
            width: '500px',
            data: {
                quantidadeContas: itens.length,
                formasRecebimento: this.listaFormaRecebimento,
            }
        });

        dialogRef.afterClosed().subscribe((res: AlterarFormaRecebimentoDialogResult) => {
            if (!res?.confirm) return;
            if (!res.idFormaRecebimento) return;

            const msg = `Você está prestes a alterar a forma de recebimento de ${itens.length} ${itens.length === 1 ? 'parcela' : 'parcelas'}. Tem certeza disso?`;
            this.abrirConfirmCobrancaInfo(
                itens.map(i => i.idContasReceberParcela),
                'Alterar Forma de Recebimento', msg, 'Confirmar', 'Cancelar',
                () => this.enviarAlterarFormaRecebimento(itens, res.idFormaRecebimento!)
            );
        });
    }

    private enviarAlterarFormaRecebimento(itens: ContasReceberGridItemStruct[], idFormaRecebimento: number): void {
        if (this._isLoading) return;
        this._isLoading = true;

        const request = new ContasReceberBulkAlterarFormaRecebimentoRequest();
        request.idsParcelas = itens.map(i => i.idContasReceberParcela);
        request.idFormaRecebimento = idFormaRecebimento;

        this.contasReceberService.bulkAlterarFormaRecebimento(request).subscribe({
            next: (response) => {
                this._isLoading = false;
                if (response.isError) {
                    this.alertService.show('Atenção', response.errorDescription, AlertType.warning);
                    return;
                }
                this.alertService.show('Sucesso', 'Forma de recebimento alterada com sucesso.', AlertType.success);
                if (response.avisoDescricao) this.mostrarAvisoCobranca(response.avisoDescricao);
                this.clickPesquisar();
            },
            error: (err) => {
                this._isLoading = false;
                this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
            }
        });
    }

    // --- Gerar Cobrança ---

    public gerarCobranca(row: ContasReceberGridItemStruct): void {
        const id = row.idContasReceberParcela;
        if (this.gerandoCobrancaMap.get(id)) return;

        const confirmRef = this.dialog.open(ConfirmModalComponent, {
            width: '440px',
            data: {
                title: 'Gerar cobrança?',
                innerHtml: `Deseja gerar a cobrança da parcela <strong>${row.descricao ?? ''}</strong> agora?`,
                buttonConfirm: 'Sim, gerar',
                buttonClose: 'Cancelar',
            },
        });

        confirmRef.afterClosed().subscribe((confirmRes: any) => {
            if (!confirmRes?.confirm) return;

            this.gerandoCobrancaMap.set(id, true);

            // Modal de feedback: faz a geração e mostra o resultado (boleto → linha digitável + PDF; PIX → confirmação).
            // Pode ser fechado a qualquer momento — a geração segue no servidor (background), como antes.
            const dialogRef = this.dialog.open(GerarCobrancaDialogComponent, {
                width: '460px',
                data: { idContasReceberParcela: id, descricao: row.descricao }
            });

            dialogRef.afterClosed().subscribe(() => {
                this.gerandoCobrancaMap.set(id, false);
                // Atualiza a lista sempre que o dialog fechar — o texto do próprio dialog convida o usuário
                // a fechar antes da geração terminar, então não dá para confiar só num "sucesso" no retorno.
                this.clickPesquisar();
            });
        });
    }

    // --- Agrupamento de Parcelas ---

    public agruparContas(): void {
        const itens = this.selection.selected;
        if (!itens || itens.length === 0) {
            this.alertService.show('Aviso', 'Selecione as parcelas que deseja agrupar.', AlertType.warning);
            return;
        }

        const idsParcelas = itens.map(i => i.idContasReceberParcela);

        this._isLoading = true;
        this.contasReceberService.validarAgrupamento({ idsParcelas }).subscribe({
            next: (res: any) => {
                this._isLoading = false;
                if (res.isError) {
                    this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
                    return;
                }

                const navegar = () => this.router.navigate(['/financas/contas-receber/cadastrar'], {
                    queryParams: {
                        modoAgrupamento: true,
                        idCliente: res.idCliente,
                        valorTotal: res.valorTotalAgrupamento,
                        idsParcelasOrigem: JSON.stringify(idsParcelas)
                    }
                });

                // Aviso prévio: agrupar cancela as parcelas originais e suas cobranças (PIX/boleto)
                const temCobrancaSelecao = itens.some(i => this.temCobranca(i));
                if (temCobrancaSelecao) {
                    this.abrirConfirmCobrancaInfo(
                        idsParcelas,
                        'Atenção — Agrupamento de Contas',
                        'As parcelas selecionadas serão canceladas e substituídas por um novo documento consolidado.',
                        'Continuar', 'Voltar',
                        () => navegar()
                    );
                } else {
                    navegar();
                }
            },
            error: (err: any) => {
                this._isLoading = false;
                this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
            }
        });
    }

    public desagrupar(row: ContasReceberGridItemStruct): void {
        const dialogRef = this.dialog.open(ConfirmModalComponent, {
            data: {
                title: 'Desagrupar este lançamento?',
                innerHtml:
                    'Ao continuar, as parcelas originais serão reabertas e as <b>cobranças ativas deste agrupamento (PIX ou boleto) serão canceladas automaticamente</b>. O histórico das cobranças será preservado para auditoria.',
                buttonConfirm: 'Sim, desagrupar',
                buttonClose: 'Cancelar',
            },
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (!result?.confirm) return;

            this._isLoading = true;
            this.contasReceberService.desagrupar(row.idContasReceber!).subscribe({
                next: (res: any) => {
                    this._isLoading = false;
                    if (res.isError) {
                        this.alertService.show('Erro', res.errorDescription || 'Erro ao desagrupar.', AlertType.error);
                        return;
                    }
                    if (res.avisoDescricao) this.mostrarAvisoCobranca(res.avisoDescricao);
                    this.alertService.show('Sucesso', 'Agrupamento desfeito com sucesso.', AlertType.success);
                    this.clickPesquisar();
                },
                error: (err: any) => {
                    this._isLoading = false;
                    this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
                }
            });
        });
    }
}
